import { FilterItemType } from '@otp/ui';
import { TFunction } from 'i18next';
import { UsersServerSideField } from 'src/components/common/users/users-serverside';
import { Tag, User } from 'src/graphql/generated/graphql';
import { getFullName } from 'src/utils/user-data';

type GetFilterConfigProps = {
  t: TFunction;
  tags: Tag[];
};

export const getFilterConfig = ({ t, tags }: GetFilterConfigProps) => [
  {
    id: 'tagIds',
    size: 2,
    type: FilterItemType.Select,
    props: {
      inputProps: {
        placeholder: t('common.tags'),
        variant: 'outlined',
        name: 'tagIds',
        label: t('common.tags'),
      },
      options: tags.map((tag) => ({
        value: tag.id,
        name: tag.name,
      })),
    },
  },
  {
    id: 'isDisabled',
    size: 2,
    type: FilterItemType.Select,
    props: {
      disableClearable: true,
      inputProps: {
        placeholder: t('common.status.label'),
        name: 'isDisabled',
        label: t('common.status.label'),
      },
      options: [
        {
          value: false,
          name: t('common.active'),
        },
        {
          value: true,
          name: t('common.inactive'),
        },
      ],
    },
  },
  {
    id: 'assignedToUserId',
    size: 2,
    type: FilterItemType.Custom,
    render: (props: any) => (
      <UsersServerSideField {...props}></UsersServerSideField>
    ),
    props: {
      inputProps: {
        placeholder: t('common.userIds'),
        variant: 'outlined',
        name: 'assignedToUserId',
        label: t('common.userIds'),
      },
    },
  },
];
